import { MpVehicle } from 'models/VehicleSelection/MpVehicle'

export const getVehicleReportFilter = (
  response: any,
  vehicle: MpVehicle
): boolean =>
  response.uniqueIdentity === vehicle.uniqueIdentity &&
  response.dataDate === vehicle.dataDate
